import React, { useCallback, useContext } from "react";
import clsx from "clsx";

import * as AnalyticsUtils from "../../../lib/util/AnalyticsUtils";
import Link from "../../nav/Link/Link";
import { IconBrightMileLogo, IconBrightMileLogoFull } from "../../../assets";
import * as EnvironmentUtils from "../../../lib/util/EnvironmentUtils";
import * as UserSelectors from "../../../store/User/User.selector";
import { useSelector } from "../../../lib/hook/ReduxHooks";

interface LogoProps {
	className?: string;
	showMobile?: boolean;
	onClick?: Function;
	noClickThrough?: boolean;
	trackingContext?: any;
	href?: string;
}

const Logo: React.FC<LogoProps> = (props) => {
	const { isLoggedIn } = useSelector((state: any) => ({
		isLoggedIn: UserSelectors.selectIsLoggedIn(state),
	}));

	const trackingContext = useContext(AnalyticsUtils.TrackingContext);

	const { className, showMobile, onClick, noClickThrough, href } = props;

	const handleClick = useCallback(() => {
		if (typeof onClick === "function") {
			onClick();
		}

		AnalyticsUtils.sendEvent({
			eventCategory: "Logo",
			eventAction: "click",
			eventLabel: `${trackingContext}`,
			mixpanelProperties: {
				name: "Logo Click",
				Context: trackingContext,
			},
		});
	}, [onClick, trackingContext]);

	return (
		<Link
			href={noClickThrough ? "" : href ? href : isLoggedIn ? "/home" : "/"}
			className={clsx("Logo", className, {
				"--showMobile": showMobile,
			})}
			onClick={handleClick}
			disabled={noClickThrough}
			doNotTrack={true}
			sameWindow={true}
		>
			<IconBrightMileLogoFull className={"Logo__icon"} />
			<IconBrightMileLogo className={"Logo__icon-small"} />
			{!EnvironmentUtils.isProduction() && (
				<span className={"Logo__env"}>
					{EnvironmentUtils.getAppEnvironmentDisplayName(false).toUpperCase()}
				</span>
			)}
		</Link>
	);
};

export default Logo;
